import React, { useEffect, useState } from "react";

import { getAuth } from "firebase/auth";
import { getTenantIdFromHost } from "../Tenant/getTenantId";

export default function Privacy() {
  const auth = getAuth();

  const tenantId = getTenantIdFromHost();

  const [headerLogo, setHeaderLogo] = useState("/kundresa_logo.png");

  const isSignedIn = !!auth.currentUser;

  return (
    <div className="publicPage">
      <div className="publicHeader">
        <a
          href="/"
          style={{
            fontSize: 22,
            textShadow: "2px 2px 3px #f3f0e8f1",

            color: "#4f354a",
            padding: 10,
            position: "absolute",
            left: 0,
          }}
        >
          ←HEM
        </a>
        {tenantId ? (
          // <img
          //   className="indexLogo"
          //   src={`/logos/${tenantId}_logo.png`}
          //   alt={`${tenantId} logo`}
          // />
          <img
            className="indexLogo"
            src={headerLogo}
            alt={`${tenantId} logo`}
          />
        ) : (
          <img
            className="indexLogo"
            src={"/kundresa_logo.png"}
            alt="Kundupplevelse logo"
          />
        )}
      </div>
      <div className="devider50"></div>

      <div className="publicCard">
        <div className="publicBody">
          <h2>Integritetspolicy</h2>

          <h3>Vi värnar om din personliga integritet.</h3>
          <p>
            När du tar emot en enkät via detta system behandlas vissa uppgifter,
            såsom namn, kontaktuppgifter och svar på enkäten. Uppgifterna
            används enbart i syfte att följa upp kundupplevelsen och förbättra
            verksamheten.
          </p>
          <p>
            Vi delar inte dina uppgifter med tredje part utöver de tekniska
            tjänster som används för utskick (t.ex. SMS och e-post).
          </p>
          <p>
            Uppgifterna sparas endast så länge det är nödvändigt för uppföljning
            och analys.
          </p>
          <p>
            Om du har frågor kring hur dina uppgifter hanteras är du välkommen
            att kontakta oss.
          </p>
        </div>
      </div>
 <div className="devider150"></div>

       <footer className="app-footer">
            För supportärenden, kontakta{" "}
            <a href="mailto:jenni@kundupplevelse.com">
              jenni@kundupplevelse.com
            </a>
          </footer>
    </div>
  );
}
